<vitamui-common-data [label]="displayObject().displayRule.ui.label | translate" [value]="value"></vitamui-common-data>
